export default __webpack_public_path__ + "static/media/featRaceBgMb.de47c182.png";